import { getMarketingCtaLink } from "@stadium/helpers/marketing";

import { SNACKMAGIC } from "@stadium/ui/src/components/brands/all/constants";
import {
  AUTOMATED_GIFTING,
  AUTOMATED_GIFTING_TITLE,
  BULK_SWAG,
  BULK_SWAG_TITLE,
  IN_PERSON_SNACKS,
  IN_PERSON_SNACKS_TITLE,
  ON_DEMAND_SWAG,
  ON_DEMAND_SWAG_TITLE,
  OTHER_OFFERINGS,
  RECIPIENTS_CHOICE_OFFERINGS,
  RECOGNITION_PROGRAMS,
  RECOGNITION_PROGRAMS_TITLE,
  SENDERS_CHOICE_OFFERINGS,
  SEND_ITEMS,
  SHOPS,
  SHOPS_TITLE,
  SNACK_BOXES,
  SNACK_BOXES_TITLE,
  SWAG_KITS_CHOICES,
  SWAG_KITS_CHOICES_TITLE,
  SWAG_STORAGE,
  SWAG_STORAGE_TITLE,
  SWAG_KITS,
} from "@constants/offerings/category";

import shopsImg from "@images/offerings/shops.png";
import sanckBoxes from "@images/offerings/snack-boxes.png";
import inPersonSnacks from "@images/offerings/in-person-snacks.png";
import recognitionPrograms from "@images/offerings/recognition-programs-small.png";
import bulkSwagImg from "@images/offerings/bulk-swag.png";
import sendItemsImg from "@images/offerings/send-items.png";
import swagKits from "@images/offerings/swag-kits.png";
import swagStorage from "@images/offerings/swag-storage.png";
import automatedGifting from "@images/offerings/automated-gifting.png";
import onDemandSwagImg from "@images/offerings/on-demand-swag.png";
import { OFFERINGS_PATH } from "@constants/routes";

const DEFAULT_OBJ = {};

export const RECIPIENT = "recipient";
export const SENDERS = "sender";
export const CAMPAIGNS = "campaigns";
export const PEER_TO_PEER = "peer-to-peer";
export const LOCKER = "locker";
export const IN_PERSON = "in-person";

export const DEFAULT_OFFERINGS = "offerings";

export const LAUNCHPAD_FEATURE_PREFIX = "launchpad";

export const OFFERINGS_CONTENT_MAPPING = {
  heading: "LET’S GET STARTED",
  description: "Which offering are you interested in?",
  ctaText: "BACK",
  ctaLink: "",
};

const getOfferingsLink = (path) => {
  return `${OFFERINGS_PATH}/${path}`;
};

export const OFFERINGS_TYPE = ({ isAuthenticated, flags = DEFAULT_OBJ } = DEFAULT_OBJ) => {
  return [
    {
      key: SHOPS,
      value: `${RECIPIENTS_CHOICE_OFFERINGS}/${SHOPS}`,
      title: SHOPS_TITLE,
      img: shopsImg,
      learnMoreLink: getMarketingCtaLink({ isAuthenticated, path: SHOPS }),
      getStartedLink: getOfferingsLink(`${RECIPIENTS_CHOICE_OFFERINGS}/${SHOPS}`),
    },
    {
      key: SNACK_BOXES,
      value: SNACK_BOXES,
      title: SNACK_BOXES_TITLE,
      img: sanckBoxes,
      learnMoreLink: getMarketingCtaLink({ isAuthenticated, path: SNACKMAGIC.key }),
      getStartedLink: getOfferingsLink(SNACK_BOXES),
    },
    {
      key: IN_PERSON_SNACKS,
      value: IN_PERSON_SNACKS,
      title: IN_PERSON_SNACKS_TITLE,
      img: inPersonSnacks,
      learnMoreLink: getMarketingCtaLink({ isAuthenticated, path: IN_PERSON }),
      getStartedLink: getOfferingsLink(IN_PERSON_SNACKS),
    },
    {
      key: RECOGNITION_PROGRAMS,
      value: RECOGNITION_PROGRAMS,
      title: RECOGNITION_PROGRAMS_TITLE,
      img: recognitionPrograms,
      learnMoreLink: getMarketingCtaLink({ isAuthenticated, path: PEER_TO_PEER }),
      getStartedLink: getOfferingsLink(RECOGNITION_PROGRAMS),
    },
    {
      key: AUTOMATED_GIFTING,
      value: AUTOMATED_GIFTING,
      title: AUTOMATED_GIFTING_TITLE,
      img: automatedGifting,
      learnMoreLink: getMarketingCtaLink({ isAuthenticated, path: CAMPAIGNS }),
      getStartedLink: getOfferingsLink(AUTOMATED_GIFTING),
    },
    {
      key: ON_DEMAND_SWAG,
      value: ON_DEMAND_SWAG,
      title: ON_DEMAND_SWAG_TITLE,
      img: onDemandSwagImg,
      learnMoreLink: getMarketingCtaLink({ isAuthenticated, path: ON_DEMAND_SWAG }),
      getStartedLink: getOfferingsLink(ON_DEMAND_SWAG),
    },
    {
      key: BULK_SWAG,
      value: `${OTHER_OFFERINGS}/${BULK_SWAG}`,
      title: BULK_SWAG_TITLE,
      img: bulkSwagImg,
      learnMoreLink: getMarketingCtaLink({ isAuthenticated, path: BULK_SWAG }),
      getStartedLink: getOfferingsLink(`${OTHER_OFFERINGS}/${BULK_SWAG}`),
    },
    {
      key: SWAG_KITS_CHOICES,
      value: SWAG_KITS_CHOICES,
      title: SWAG_KITS_CHOICES_TITLE,
      img: swagKits,
      learnMoreLink: getMarketingCtaLink({ isAuthenticated, path: SWAG_KITS }),
      getStartedLink: getOfferingsLink(SWAG_KITS_CHOICES),
    },
    {
      key: SWAG_STORAGE,
      value: SWAG_STORAGE,
      title: SWAG_STORAGE_TITLE,
      img: swagStorage,
      learnMoreLink: getMarketingCtaLink({ isAuthenticated, path: LOCKER }),
      getStartedLink: getOfferingsLink(SWAG_STORAGE),
    },
    {
      key: SEND_ITEMS,
      value: `${SENDERS_CHOICE_OFFERINGS}/${SEND_ITEMS}`,
      title: "Send Items",
      img: sendItemsImg,
      learnMoreLink: getMarketingCtaLink({ path: SEND_ITEMS }),
      getStartedLink: getOfferingsLink(`${SENDERS_CHOICE_OFFERINGS}/${SEND_ITEMS}`),
    },
  ];
};
